import React from "react";
import { NavLink } from "react-router-dom";
import { 
  FiHome, 
  FiFileText, 
  FiUsers, 
  FiSettings, 
  FiUserPlus, 
  FiLogOut,
  FiStar // Naya icon reviews ke liye
} from "react-icons/fi";
import { logout } from "../services/auth";
import logo from "../assets/images/achal_logo.png";

const Sidebar = () => {
  const menu = [
    { name: "Dashboard", icon: <FiHome />, path: "/dashboard" },
    { name: "All Tickets", icon: <FiFileText />, path: "/tickets" },
    { name: "Performance Reviews", icon: <FiStar />, path: "/reviews" }, //  Tickets ke turant baad
    { name: "Our Workers", icon: <FiUsers />, path: "/workers" },
    { name: "Add Worker", icon: <FiUserPlus />, path: "/add-worker" },
    { name: "Settings", icon: <FiSettings />, path: "/settings" },
  ];

  return (
    <div style={styles.sidebar}>
      {/* 🏛️ PREMIUM LOGO SECTION */}
      <div style={styles.logoSection}>
        <img 
          src={logo} 
          alt="Achal Jewels" 
          style={styles.mainLogo} 
        />
        <div style={styles.logoDivider}></div>
        <p style={styles.subLogo}>HOD Dashboard</p>
      </div>

      {/* 🧭 NAVIGATION MENU */}
      <div style={styles.menu}>
        {menu.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            style={({ isActive }) => ({
              ...styles.item,
              ...(isActive ? styles.active : styles.nonActive),
            })}
          >
            {({ isActive }) => (
              <>
                <span style={{ ...styles.icon, color: isActive ? "#000" : "#D4AF37" }}>
                  {item.icon}
                </span>
                <span>{item.name}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>

      {/* 🚪 LOGOUT SECTION */}
      <div style={styles.bottomSection}>
        <div style={styles.logoutBtn} onClick={logout}>
          <FiLogOut style={styles.icon} />
          <span>Sign Out</span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  sidebar: {
    width: "280px", // Thoda width badha di luxury feel ke liye
    height: "100vh",
    background: "#FFFFFF",
    padding: "40px 20px",
    position: "fixed",
    display: "flex",
    flexDirection: "column",
    boxShadow: "10px 0 40px rgba(0,0,0,0.02)",
    zIndex: 100,
    top: 0,
    left: 0,
    boxSizing: "border-box",
  },
  logoSection: {
    marginBottom: "50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flexShrink: 0,
  },
  mainLogo: {
    height: "80px", // Logo ko thoda bada aur clear kiya
    width: "auto",
    objectFit: "contain",
  },
  logoDivider: {
    width: "40px",
    height: "2px",
    background: "#D4AF37",
    margin: "15px 0 10px 0",
    borderRadius: "2px",
    opacity: 0.6
  },
  subLogo: { 
    fontSize: "11px", 
    color: "#94A3B8", 
    fontWeight: "700", 
    textTransform: "uppercase", 
    letterSpacing: "2px"
  },
  menu: { 
    display: "flex", 
    flexDirection: "column", 
    gap: "10px", 
    flex: 1,
    overflowY: "auto",
    paddingRight: "5px"
  },
  item: { 
    display: "flex", 
    alignItems: "center", 
    gap: "15px", 
    padding: "16px 20px", 
    borderRadius: "18px", 
    cursor: "pointer", 
    transition: "0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    fontSize: "14px",
    fontWeight: "600",
    textDecoration: "none",
  },
  active: { 
    background: "#D4AF37", 
    color: "#000", 
    boxShadow: "0 12px 25px rgba(212, 175, 55, 0.3)",
    transform: "translateX(5px)"
  },
  nonActive: { 
    color: "#64748B",
    background: "transparent",
  },
  icon: { fontSize: "22px" },
  bottomSection: {
    marginTop: "auto",
    paddingTop: "25px",
    borderTop: "1px solid #F1F5F9",
  },
  logoutBtn: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    padding: "16px 20px",
    borderRadius: "18px",
    cursor: "pointer",
    color: "#EF4444", 
    background: "#FFF1F2", 
    transition: "0.3s",
    fontWeight: "700",
    fontSize: "14px"
  }
};

export default Sidebar;